import { Principal } from '@dfinity/principal'
import Wallet from '../wallet'
import { Secp256k1KeyIdentity } from '@dfinity/identity-secp256k1'
import { Ed25519KeyIdentity } from '@dfinity/identity'

export enum KeychainType {
  HDKeychain = 'HDKeychain',
  KeyPairKeychain = 'KeyPairKeychain',
}

export interface IKeyChain {
  type: string
  serialize(): Promise<unknown>
  deserialize(options: unknown): Promise<void>
  addNewAccount(): Promise<Array<Wallet>>
  getPrincipals(): Promise<Principal[]>
  getIdentity(principal: string): Promise<Secp256k1KeyIdentity | Ed25519KeyIdentity>
  exportKeychain(): Promise<string>
  exportPem(principal: string): Promise<string>
}
